/**
 *
 * 
 *  shiftUp: {sequence: string, action: string}, 让下一个Table的第一个元素聚焦
 *  shiftDown: {sequence: string, action: string} 让上一个Table的第一个元素聚焦
 *
 * 
 */

const keyMap = {
    shiftUp: {
        sequence: 'shift+up',
        action: 'keydown',
    },
    shiftDown: {
        sequence: 'shift+down',
        action: 'keydown',
    },
    tab: {
        sequence: 'tab',
        action: 'keydown',
    },
};

export { keyMap };